// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__22neA","info":"PatientInfo_info__2Hdfe"};